


































import { defineComponent } from '@vue/composition-api';

import { moduleList } from '@/views/Report/CSV/csv-report-router';
import useAuth from '@/useAuth';

const List = defineComponent({
  setup() {
    const { hasPermission } = useAuth();

    return {
      hasPermission,
      moduleList,
    };
  },
});

export default List;
